import styled, { css } from "styled-components";
import { transparentize } from "polished";

import { IStyledImageStyleProps } from "./interfaces";

export const StyledImage = styled.div<IStyledImageStyleProps>`
    display: inline-block;
    position: relative;
    margin-bottom: 12px;
    background-position: center;
    background-size: cover;
    canvas {
        transform: scale(0.5);
        transform-origin: top left;
    }
    ${p =>
        p.theme.sm.min(css`
            min-width: 290px;
            max-width: 300px;
            float: left;
            margin-right: 24px;
            margin-bottom: 10px;
        `)}
    ${p =>
        p.theme.xs(css`
            width: 100%;
        `)}
    box-shadow: 1px 1px 10px 2px ${p => p.theme.c.blackShadow5};
    border-radius: 8px;
    
    .i-image {
        display: block;
        font-size: 56px;
    }

    .Black {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${p => p.theme.c.blackShadow35};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: ${p => p.theme.c.snow};
        opacity: 0;
        z-index: 1;
        transition: opacity 0.2s;
        border-radius: 8px;
    }
    .ImageContainer {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 8px;
    }
    .Image {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: cover;
        background-position: center;
        background-color: ${p => p.theme.c.snow};
        transition: transform 300ms;
    }
    &:hover {
        .Black {
            opacity: 1;
        }
        .Image {
            ${p =>
                !p.publicView
                    ? css`
                          transform: scale(1.03);
                      `
                    : undefined}
        }
    }
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 12px;
    grid-row-gap: 12px;

    > div {
        margin-bottom: 0;
    }

    ${p =>
        p.theme.xs(css`
            grid-template-columns: 1fr;
        `)}

    ${p =>
        p.theme.sm.only(css`
            grid-template-columns: 1fr 1fr;
        `)}
`;

export const ChangeImage = styled.div`
    cursor: pointer;
    padding: 10px;

    .i-image {
        color: ${p => p.theme.c.whiteOnActive};
        transform: scale(0.9);
        transition: 300ms;
    }

    &:hover {
        .i-image {
            transform: scale(1.04);
        }
    }
`;

export const ChangeImageModal = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    background-color: ${p => p.theme.c.blackShadow3};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${p => p.theme.c.snowOnActive};
    font-size: 24px;
    transition: opacity 300ms;
    &:hover {
        opacity: 1;
    }

    &.Disabled {
        color: ${p => p.theme.c.disabled};
        cursor: progress;
    }
`;

export const UploadButton = styled.button`
    margin-left: 24px;
`;

export const Scaler = styled.div`
    width: 200px;
    height: 3px;
    background-color: ${p => p.theme.c.dark};
    margin: 32px auto;
    position: relative;
`;

export const ScalerDrag = styled.div`
    width: 32px;
    height: 32px;
    background-color: ${p => transparentize(1 - 0.7, p.theme.c.snow)};
    border-radius: 32px;
    position: absolute;
    left: 0%;
    margin-left: -16px;
    margin-top: -16px;
    border: 2px solid ${p => p.theme.c.dark};
    cursor: pointer;
`;

export const BackButton = styled.button`
    position: absolute;
    top: 9px;
    left: 10px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none;
    .i-arrowback {
        color: ${p => p.theme.c.disabled};
        font-size: 50px;
    }
`;

export const Loading = styled.div`
    &.Active {
        pointer-events: none;
    }
`;

export const Cropper = styled.div`
    margin-top: 16px;
    margin-bottom: -16px;
    &.Loading {
        cursor: progress;
    }
    ${StyledImage} {
        float: none;
        margin: auto;
        display: block;
        width: 320px;
        max-width: 320px;
        margin-bottom: 36px;
    }
    canvas {
        display: block;
    }
    ${p =>
        p.theme.xs(css`
            margin: 0 -24px;
            .button {
                width: calc(100% - 48px);
                margin: 0 24px;
            }
        `)}
`;
